import {
  Input,
  OnInit,
  Inject,
  Component,
} from 'ng-metadata/core';

import { DialogService } from 'services/dialog.service';
import { PopulateService } from 'services/populate.service';

import addressHtml from './address.html';
import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from 'constants';

/**
 * Address Form Component
 *
 * Encapsulates behavior and
 * template for an address form.
 */
@Component({
  selector: 'gwFormAddress',
  template: addressHtml,
})
export class FormAddressComponent implements OnInit {
  public GW = (<any>window).GW;
  public states = this.GW.states;
  public countries = this.GW.countries;
  public addressForm;

  public countryNotSupported = false;
  public postalCode = {
    pattern: /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] *\d[A-Z]\d)$/,
  };

  @Input() address;

  constructor(
    @Inject(DialogService) private dialogService: DialogService,
    @Inject(PopulateService) private populateService: PopulateService,
  ) {}

  ngOnInit() {
  }

  poAddressValid() {
    const currentAddress = this.address.address;

    if (currentAddress === undefined) {
      return;
    }

    const combinations = [
      'p.o. box',
      'p.o box' ,
      'po box' ,
      'po.' ,
      'p.o' ,
      'p. o' ,
      'p o.' ,
      'p. o.' ,
      'pob ',
      'p o box',
      'p obox',
      'p. o. box',
      'pobox ',
      'post office box',
    ];

    let flag = true;
    const containPOAddress = combinations.filter(
      item => currentAddress.toLowerCase().includes(item),
    );

    if (containPOAddress.length > 0) {
      flag = false;
    }

    this.addressForm.street.$setValidity('addressPOBox' , flag);

  }

  async queryPlaces(addressQuery: string) {
    try {
      const items = await this.populateService.addressyFind(addressQuery);
      return items;
    } catch (e) {
      throw e;
    }
  }

  async autofillAddress(prediction) {
    if (!prediction || !prediction.Id) {
      return;
    }

    try {
      const items = await this.populateService.addressyRetrieve(prediction.Id);

      const address = Array.isArray(items) && items.length && items[0];
      if (address) {
        this.address.address = address.Line1;
        this.address.address2 = address.Line2;
        this.address.locality = address.City;
        this.address.region = address.ProvinceCode;
        this.address.country = address.CountryIso2;
        this.address.postalCode = address.PostalCode;
      }
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/address/address.component.ts